import styled from "styled-components";

export const InputGroupRowLayout = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 0.5rem;
    padding-bottom: 2.2rem;
`;
